let Routes = /*#__PURE__*/function (Routes) {
  Routes["PORTALS"] = "/portals";
  Routes["ENTRIES"] = "/entries";
  Routes["COURSES"] = "/courses";
  Routes["TEAMS"] = "/teams";
  Routes["SPEECH"] = "/speech";
  Routes["FONT"] = "/font";
  Routes["STATUS"] = "/status";
  return Routes;
}({});

export { Routes };
//# sourceMappingURL=const.routes.js.map
